
import {useMemo} from 'react';
import {gql, useQuery} from '@apollo/client';
import {API_APPT, ApiAppt, ObjAppt} from 'components/checkout/query/types.api-appt';

interface Vars {
	appt: string
}

interface Result {
	appt: {
		info: ApiAppt
	}
}

const getAppt = gql`
${API_APPT}
query ($appt: ID!) {
	appt(id: $appt) {
		info: details {
			...ApiAppt
		}
	}
}`;

export const useAppt = (variables: Vars) => {
	const {data, loading} = useQuery<Result, Vars>(getAppt, {
		variables,
	});

	const appt = useMemo(() => (
		new ObjAppt(data?.appt.info).props()
	), [data?.appt]);

	return {
		appt,
		loading,
	};
};
